const subscriptions = {};

function on(name, callback) {
  if (!subscriptions[name]) {
    subscriptions[name] = {
      subscribed: [],
    };
  }
  subscriptions[name].subscribed.push(callback);
}

function off(name, callback) {
  if (subscriptions[name]) {
    if (callback) {
      subscriptions[name].subscribed = subscriptions[name].subscribed.filter(existingCallback => callback !== existingCallback);
    } else {
      subscriptions[name].subscribed = [];
    }
  }
}

function trigger(name, data) {
  if(subscriptions[name]){
    subscriptions[name].subscribed.forEach(callback => callback(data));
  }
}

module.exports = {
  on,
  off,
  trigger,
};



// WEBPACK FOOTER //
// ./src/app/libs/bus.js